import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { useUI } from "providers/UIProvider";

import reservationsService from "api/reservationsService";
import { IUpdateReservationBoxURLParams } from "types/reservation";
import { AxiosError } from "axios";


const useUpdateReservationBoxMutation = ()=> {
  const { T } = useUI()
  return useMutation(async(params: IUpdateReservationBoxURLParams) => {
      const res = await reservationsService.updateReservationBox(params)

      return res.data
  }, {
    onError: (err: AxiosError<any>) => {
      toast.error(T(`${err.response?.data.MessageId}`) ||T("general.error"))
    }
  })
}

export default useUpdateReservationBoxMutation